module.exports = __webpack_public_path__ + "img/语音压缩banner.9a23817c.png";